export default __webpack_public_path__ + "static/media/ColorfulStars.4bc6e672.svg";